var vm;

(function () {
    'use strict';

    var controllerId = 'gateOperationInventory';

    angular.module('app.controllers').controller(controllerId, gateOperationInventory)

    gateOperationInventory.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams', '$translate', 'moment'];

    function gateOperationInventory(common, datacontext, $http, $scope, $stateParams, $translate, moment) {
        var config = common.config;
        vm = this;
        vm.selectLabel = "Seleccione";
        //Pagination config
        vm.totalItems = 0;
        vm.itemsPerPage = 10;
        vm.currentPage = 1;
        vm.export = false;
        vm.displayInfoNoData = true;
        vm.disabledBtnSearch = false;
        vm.disabledBtnExport = false;
        vm.maxRangeDays = 30;

        vm.criteria = {
            depotId : null,
            carrierIds: [],
            movementTypeId: null,
            sizeTypeId: null,
            actionType: "",
            fromDate: null,
            toDate: null
        };

        vm.carrierName = "";
        vm.carrierId = null;
        vm.carrierFilterDisabled = false;

        vm.truckerFilterDisabled = false;
        $scope.selectedTrucker = {};
        vm.movementTypeModel = {};

        vm.listDepot = [];
        vm.listCarrier = [];
        vm.listSizeType = [];
        vm.sizeTypeModel = null;
        vm.listMovementType = [];
        vm.actionTypeList = [];
        vm.listSizeType = [];

        vm.gateOperationInventoryList = [];

        String.prototype.format = function()
        {
            var content = this;
            for (var i=0; i < arguments.length; i++)
            {
                var replacement = '{' + i + '}';
                content = content.replace(replacement, arguments[i]);
            }
            return content;
        };

        vm.init = function() {
            common.activateController([ vm.fnSetSelectLabel(), vm.fnGetDateRangeSetting()])
                  .then(function (data) {
                    vm.listDepot.unshift({ Id: null, Name: vm.selectLabel });
                    vm.criteria.yardId = vm.listDepot[0].Id;
                    vm.listMovementType.unshift({ Id: null,  Name: vm.selectLabel });
                    vm.criteria.movementTypeId = vm.listMovementType[0].Id;
                    vm.listSizeType.unshift({ Id: null, Name: vm.selectLabel });
                    vm.criteria.sizeTypeId = vm.listSizeType[0].Id;
                  });
            vm.fnConfigureControls();
            vm.fnFillFilterData();
            vm.fnSetRoleInformation();
        }

        vm.fnSetSelectLabel = function(){
            vm.selectLabel = $translate.instant('views.gateoperationinventory.choose');
        }

        vm.fnGetDateRangeSetting = function() {
            const categoryName = "Portal Reportes - Date Range";
            const settingName = "Reporte GTI-GTO";
            datacontext.gateoperationinventory.getApplicationSettingValue(categoryName, settingName).then(function (value) {
                if (value) {
                    vm.maxRangeDays = Number(value);
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        vm.fnFillFromToDate = function() {
            var now = moment();
            vm.criteria.fromDate = now.clone().add(-7, 'day').format("DD/MM/YYYY");
            vm.criteria.toDate = now.format("DD/MM/YYYY");
        }

        vm.fnSetRoleInformation = function() {
            var authData = common.localStorageService.get('authorizationData');
            vm.roleSelected = authData ? authData.userRole : "";
            vm.isOnlyPortalUser = authData ? authData.isOnlyPortalUser : false;
            vm.fnSetIsCarrier();
            vm.fnSetIsTrucker();
        }

        vm.fnSetIsCarrier = function() {
            var userRole = common.localStorageService.get('GetRolesByUserQuery');
            vm.isCarrier = vm.isOnlyPortalUser && userRole.isCarrier;
            if (vm.isCarrier) {
                vm.carrierFilterDisabled = true;
                var bpAssociated = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
                if (bpAssociated) {
                    vm.carrierName = bpAssociated.Name;
                    vm.carrierId = bpAssociated.BusinessPartnerId;
                    // carrierIds lo asigna fnUpdateCarrierFilter con el objeto completo {id, label}
                } else {
                }
            }
            else {
                vm.carrierFilterDisabled = false;
            }
        }

        vm.fnSetIsTrucker = function() {
            var userRole = common.localStorageService.get('GetRolesByUserQuery');
            vm.isTrucker = vm.isOnlyPortalUser && userRole.isTrucker;
            if (vm.isTrucker) {
                vm.truckerFilterDisabled = true;
                var bpAssociated = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
                if (bpAssociated) {
                    $scope.selectedTrucker = {
                        Id: bpAssociated.BusinessPartnerId, Name: bpAssociated.Name
                    };
                }
            }
            else {
                vm.truckerFilterDisabled = false;
                vm.clearTrucker();
            }
        }

        vm.fnFillActionTypes = function() {
            vm.actionTypeList.push(
                { Code: "", Name: $translate.instant('views.gateoperationinventory.both')},
                { Code: "D", Name: "Gate In" },
                { Code: "P", Name: "Gate Out" });
        }

        vm.fnConfigureControls = function() {
            $('#txtFromDate').datepicker({
                format: 'dd/mm/yyyy'
            });
            $('#txtToDate').datepicker({
                format: 'dd/mm/yyyy'
            });
        }

        vm.startDate = function () {
            $('#txtFromDate').focus();
        };

        vm.endDate = function () {
            $('#txtToDate').focus();
        };

        vm.fnFillFilterData = function() {
            vm.fnGetCarriers();
            vm.fnFillActionTypes();
            vm.fnFillFromToDate();

            datacontext.gateoperationinventory.getFilters()
                .then(function (data) {
                    if (data) {
                        if (data.Depot != null && data.Depot.length > 0) {
                            vm.fnFillDepot(data.Depot);
                        }
                        if (data.MovementType != null && data.MovementType.length > 0) {
                            vm.fnFillMovementType(data.MovementType);
                        }
                        if (data.SizeType != null && data.SizeType.length > 0) {
                            vm.fnFillSizeType(data.SizeType);
                        }
                    }

                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        };

        vm.fnSetDefaultDepot = function() {
            var authData = common.localStorageService.get('authorizationData');
            if (authData) {
                var currentYardId = authData.ModelRequester.CurrentYardId;
                if (currentYardId !== undefined)
                    vm.criteria.depotId = Number(currentYardId);
            }
        }

        vm.fnFillDepot = function (depotData) {
            angular.forEach(depotData, function (depot, key) {
                vm.listDepot.push(depot);
            });
            vm.fnSetDefaultDepot();
        };

        vm.fnFillMovementType = function (movementTypeData) {
            angular.forEach(movementTypeData, function (movementType, key) {
                vm.listMovementType.push(movementType);
            });
        };

        vm.fnFillSizeType = function (sizeTypeData) {
            angular.forEach(sizeTypeData, function (sizeType, key) {
                vm.listSizeType.push(sizeType);
            });
        };

        vm.initializeCarrier = function () {
            vm.listCarrier = [];
        };

        vm.fnGetCarriers = function () {
            vm.initializeCarrier();
            datacontext.gateoperationinventory.getCarrierList().then(function (data) {
                if (data) {
                    angular.forEach(data, function (value, key) {
                        vm.listCarrier.push({ id: value.Id, label: value.Name });
                    });
                    vm.fnUpdateCarrierFilter();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.fnUpdateCarrierFilter = function () {
            if (vm.listCarrier && vm.carrierId !== 0) {
                vm.listCarrier.forEach(function (value, key) {
                    if (value.id == vm.carrierId) {
                        vm.criteria.carrierIds = [value];
                        vm.carrierFilterDisabled = true;
                    }
                });
            }
            else {
                vm.carrierFilterDisabled = false;
            }
        }

        $scope.fnGetTruckersByName = function (name) {
            return datacontext.gateoperationinventory.getTruckersByName(name);
        };

        vm.fnOnSelectedTrucker = function (selected) {
            if (selected) {
                $scope.selectedTrucker = selected.originalObject;
            } else {
                $scope.selectedTrucker = null;
            }
        }

        vm.clearTrucker = function() {
            $scope.selectedTrucker = null;
            $scope.$broadcast('angucomplete-alt:clearInput', 'trucker');
        }

        vm.fnClearReport = function () {

           
            // Preservar valores de filtros bloqueados (disabled) antes de limpiar
            var lockedCarrierIds = vm.carrierFilterDisabled ? vm.criteria.carrierIds : [];
            var lockedTrucker    = vm.truckerFilterDisabled ? $scope.selectedTrucker : null;

            vm.gateOperationInventoryList = [];
            vm.displayInfoNoData = true;
            vm.totalItems = 0;
            vm.currentPage = 1;
            vm.itemsPerPage = 10;
            vm.export = false;

            vm.criteria = {
                depotId : null,
                carrierIds: lockedCarrierIds,
                movementTypeId: null,
                sizeTypeId: null,
                actionType: "",
                fromDate: null,
                toDate: null
            };


            // Restaurar trucker bloqueado; si no estaba bloqueado, limpiar el input
            if (lockedTrucker !== null) {
                $scope.selectedTrucker = lockedTrucker;
            } else {
                vm.clearTrucker();
            }

            vm.fnSetDefaultDepot();
            vm.fnSetRoleInformation();
            vm.fnUpdateCarrierFilter();
            vm.fnFillFromToDate();
        }

        vm.fnValidRangeDate = function() {
            let valid = true;
            var fromDate = moment(vm.criteria.fromDate, 'DD/MM/YYYY');
            var toDate = moment(vm.criteria.toDate, 'DD/MM/YYYY');
            var days = toDate.diff(fromDate, 'days');
            if (days < 0) {
                toastr.error($translate.instant('views.gateoperationinventory.validationFromDateGreater'));
                valid = false;
            }
            else if (days > vm.maxRangeDays) {
                let message = $translate.instant('views.gateoperationinventory.validationRangeDateGreater');
                toastr.error(message.format(vm.maxRangeDays));
                valid = false;
            }
            return valid;
        }

        vm.fnValidMandatories = function() {
            let valid = true;
            if (vm.criteria.depotId == null || vm.criteria.depotId == undefined || vm.criteria.depotId == "") {
                toastr.error($translate.instant('views.gateoperationinventory.validationDepot'));
                valid = false;
            }
            if (vm.criteria.toDate == null || vm.criteria.toDate == undefined || vm.criteria.toDate == "") {
                toastr.error($translate.instant('views.gateoperationinventory.validationDateTo'));
                valid = false;
            }
            if (vm.criteria.fromDate == null || vm.criteria.fromDate == undefined || vm.criteria.fromDate == "") {
                toastr.error($translate.instant('views.gateoperationinventory.validationDateFrom'));
                valid = false;
            }
            return valid;
        }

        vm.GetIdsFromMultiSelectList = function (selectedItems) {
            let ids = [];
            angular.forEach(selectedItems, function (val, key) { ids.push(val.id); });
            return ids;
        }

        vm.fnConvertDateToSQLFormat = function (date) {
            let parseDate = null;
            if (date != undefined && date != '') {
                var splitDate = date.split("/");
                parseDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
            }
            return parseDate;
        }

        vm.fnGetSearchCriteria = function(pageNumber, pageSize) {
            let criteria = {
                yardId: vm.criteria.depotId,
                carrierIdList: vm.GetIdsFromMultiSelectList(vm.criteria.carrierIds),
                movementTypeId : vm.criteria.movementTypeId,
                truckerId : $scope.selectedTrucker ? ($scope.selectedTrucker.BusinessPartnerId || $scope.selectedTrucker.Id || null) : null,
                sizeAndTypeId : vm.criteria.sizeTypeId,
                actionType: vm.criteria.actionType,
                dateFrom: vm.criteria.fromDate ? vm.fnConvertDateToSQLFormat(vm.criteria.fromDate) : null,
                dateTo: vm.criteria.toDate ? vm.fnConvertDateToSQLFormat(vm.criteria.toDate) : null,
                pageNumber: pageNumber,
                pageSize: pageSize
            };
            return criteria;
        }

        vm.searchReport = function(){
            vm.currentPage = 1;
            vm.itemsPerPage = 10;
            vm.fnSearchReport();
        }

        vm.fnSearchReport = function () {
            var valid = vm.fnValidMandatories();
            if (!valid) return;

            valid = vm.fnValidRangeDate();
            if (!valid) return;

            vm.fnGetGateOperationInventoryList();
        }

        vm.fnGetGateOperationInventoryList = function() {
            vm.displayInfoNoData = false;
            vm.disabledBtnSearch = true;

            vm.gateOperationInventoryList = [];
            let criteria = vm.fnGetSearchCriteria(vm.currentPage, vm.itemsPerPage);
            return datacontext.gateoperationinventory.getGateOperationInventoryList(criteria).then(function (data) {
                vm.disabledBtnSearch = false;
                if (data.Result == 1) {
                    vm.export = true;
                    vm.gateOperationInventoryList = angular.copy(data.Data);
                    vm.totalItems = angular.copy(data.Total);
                    if (vm.totalItems == 0){
                        vm.displayInfoNoData = true;
                        vm.export = false;
                    }
                } else {
                    toastr.info(data.Message);
                    vm.displayInfoNoData = true;
                    vm.export = false;
                }
            },
                function (err) {
                    vm.displayInfoNoData = true;
                    vm.export = false;
                    if (err.status)
                        toastr.error(err.info);
                });
        };

        vm.fnExportToExcel = function() {
            if (vm.export == true) {
                var valid = vm.fnValidMandatories();
                if (!valid) return;
                valid = vm.fnValidRangeDate();
                if (!valid) return;

                let criteria = vm.fnGetSearchCriteria(1, 30000);
                let url_ = config.basePaths.Base_Path_Resources + 'reportList/ExportGateOperationInventory';
                var authData = common.localStorageService.get('authorizationData');
                const fileName = 'ReporteGtiGto';
                var request = new XMLHttpRequest();
                request.open('POST', url_, true);
                request.setRequestHeader("Authorization", "Bearer " + authData.access_token);
                request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                request.setRequestHeader('ModelRequester', JSON.stringify(authData.ModelRequester));
                request.responseType = 'blob';
                showLoader();
                request.onload = function (e) {
                    dismissLoader();
                    if (this.status === 200) {
                        var blob = this.response;
                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveBlob(blob, fileName);
                        }
                        else {
                            var downloadLink = window.document.createElement('a');
                            var contentTypeHeader = request.getResponseHeader("Content-Type");
                            downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                            downloadLink.download = fileName;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                        }
                    }
                };
                request.send(JSON.stringify(criteria));
            }
            else {
                toastr.info($translate.instant('views.gateoperationinventory.noDataToExport'));
                return;
            }
        };

        function showLoader() {
            if ($(".custom-loader-div").length == 0) {
                $('body').prepend("<div class='custom-loader-div'><div class='custom-loader-image'/></div>");
                $('.custom-loader-div').attr("data-loadernumber", 0);
            }

            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", ++loadernumber);

        }

        function dismissLoader() {
            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", --loadernumber);

            if ($('.custom-loader-div').attr("data-loadernumber") == 0) {
                $(".custom-loader-div").remove();
            }
        }        

        vm.init();
    }
})();